import "./CircularProgress.scss";

export type CircularProgressSize = "sm" | "md" | "lg";

interface CircularProgressProps {
  size?: CircularProgressSize;
  className?: string;
  "aria-label"?: string;
}

const sizeClass: Record<CircularProgressSize, string> = {
  sm: "circular-progress--sm",
  md: "circular-progress--md",
  lg: "circular-progress--lg",
};

export const CircularProgress = ({
  size = "md",
  className,
  "aria-label": ariaLabel = "Загрузка",
}: CircularProgressProps) => (
  <span
    className={`circular-progress ${sizeClass[size]}${className ? ` ${className}` : ""}`}
    role="status"
    aria-label={ariaLabel}
  />
);
